import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass(`ScheduleCalendarContent with_white_bg ofs`),
  style: {"height":"420px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_FormContent = _resolveComponent("FormContent")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "FormContentModal",
    "content-class": "modalContent shadowContent rad10 modalStandard posFi",
    onBeforeOpen: _ctx.openModal
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.instantRoom)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            _createVNode(_component_FormContent, {
              room: _ctx.instantRoom,
              currentStep: `form`,
              additionalParams: _ctx.additionalParams,
              onCompleteForm: _ctx.completeForm,
              onChangeDate: _ctx.changeDate,
              onSkipForm: _ctx.skipForm,
              loadingFormSending: _ctx.loadingFormSending
            }, null, 8, ["room", "additionalParams", "onCompleteForm", "onChangeDate", "onSkipForm", "loadingFormSending"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onBeforeOpen"]))
}